module.exports = __webpack_public_path__ + "static/img/manual_zh_5.48f6c55.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_5.png
// module id = tMTX
// module chunks = 4